import CommunitySection from './communitySection'

export default CommunitySection
